<div class="phone-input-wrapper">
  <div class="country-selector" #countrySelector>
    <button
      type="button"
      class="country-selector-button"
      [disabled]="disabled()"
      (click)="toggleCountryDropdown()"
    >
      <span class="country-flag">{{ selectedCountry().flag }}</span>
      <span class="country-dial-code">{{ selectedCountry().dialCode }}</span>
      <svg
        width="16"
        height="16"
        viewBox="0 0 16 16"
        fill="none"
        class="dropdown-icon"
        [class.open]="isCountryDropdownOpen()"
      >
        <path
          d="M4 6L8 10L12 6"
          stroke="currentColor"
          stroke-width="2"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
      </svg>
    </button>
    @if (isCountryDropdownOpen()) {
      <div class="country-dropdown">
        @for (country of countries; track country.code) {
          <button
            type="button"
            class="country-option"
            [class.selected]="selectedCountry().code === country.code"
            (click)="onCountrySelect(country)"
          >
            <span class="country-flag">{{ country.flag }}</span>
            <span class="country-name">{{ country.name }}</span>
            <span class="country-dial-code">{{ country.dialCode }}</span>
          </button>
        }
      </div>
    }
  </div>
  <input
    [id]="inputId()"
    type="tel"
    class="form-input phone-input"
    [value]="phoneNumber()"
    [disabled]="disabled()"
    [placeholder]="
      selectedCountry().code === 'BR' ? '(  ) _____ - ____' : 'Digite o número'
    "
    (input)="formatPhoneNumber($event)"
    (blur)="onBlur()"
    maxlength="20"
  />
</div>
@if (control?.invalid && control?.touched) {
  <span class="error-message">
    @if (control?.errors?.['required']) {
      Telefone é obrigatório
    } @else if (control?.errors?.['invalid']) {
      Telefone inválido
    }
  </span>
}
